import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdDetails =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/details";

export const decisioningStudioAgentsAppGroupIdDsaIdDetailsCacheKeys: AllRouteEndpoints[] = [
  "/decisioning_studio_agents/:app_group_id/:dsa_id/details",
];
